import dayjs from "dayjs";
import { TEventLogo, TEventLogoComponent } from "../../../components/EventLogo/EventLogo";
import { IWizardData } from "../../../views/StartWizard/StartWizard";

export const getInitialEventLogoData = (
    eventLogoComponent: TEventLogoComponent | null,
    wizardData?: IWizardData | null
): TEventLogo | null => {
    if (eventLogoComponent === null) {
        return null;
    }

    const names = {
        name1: wizardData?.name1 || "Emma",
        name2: wizardData?.name2 || "Anton",
    };

    const additionalText = wizardData?.dateStart
        ? dayjs(wizardData?.dateStart).format("YYYY-MM-DD")
        : dayjs().add(1, "year").format("YYYY-MM-DD");

    if (eventLogoComponent === "BorderUpAndDown") {
        return {
            name: "BorderUpAndDown",
            ...names,
            additionalText,
            colorText: { override: false, color: null },
        };
    }

    if (eventLogoComponent === "ModernMonogramBadge") {
        return {
            name: "ModernMonogramBadge",
            ...names,
            colorText: { override: false, color: null },
            colorBackground: { override: false, color: null },
            fontSizeInitials: 9,
            distanceInitialsX: 12,
            distanceInitialsY: 6,
        };
    }

    if (eventLogoComponent === "HandDrawnHeart") {
        return {
            name: "HandDrawnHeart",
            ...names,
            colorText: { override: false, color: null },
        };
    }
    
    if (eventLogoComponent === "ModernMonogramStrikethrough") {
        return {
            name: "ModernMonogramStrikethrough",
            ...names,
            colorText: { override: false, color: null },
        };
    }

    if (eventLogoComponent === "ModernMonogramBorderBetween") {
        return {
            name: "ModernMonogramBorderBetween",
            ...names,
            additionalText,
            colorText: { override: false, color: null },
        };
    }


    if (eventLogoComponent === "RelaxedByHand") {
        return {
            name: "RelaxedByHand",
            ...names,
            colorText: { override: false, color: null },
        };
    }

    throw new Error("No initial event logo data for " + eventLogoComponent);
};
